module.exports = __webpack_public_path__ + "img/BUYMeister.710693d3.png";